import { formatRawTextUpdated, pickRawTextAudit } from '@/custom/classes/raw_text_audit.js'

// Shared by ModalPosition and ModalPositionAdvanced: "who last changed Company
// Raw Text, and when". Expects `positionData` on the host component.
//
// Usage around a save:
//   const token = this.beginRawTextSave(text)   // before the PUT
//   ... await the PUT ...
//   this.finishRawTextSave(token, response)     // after it succeeded
// The label is refreshed only when the text differs from what was loaded /
// last saved, and an answer from a superseded save is dropped (raw_text_seq),
// so two quick blurs resolving out of order cannot leave a stale label.
export default {
  data () {
    return {
      rawTextAudit: { updated_at: null, updated_by: null },
      raw_text_baseline: null,
      raw_text_seq: 0,
      // a changed save started but no latest save has finished yet (in flight
      // or failed) — the next save must refresh even if its text equals the baseline
      raw_text_unsettled: false
    }
  },
  computed: {
    rawTextUpdatedLabel () {
      return formatRawTextUpdated(this.rawTextAudit.updated_at, this.rawTextAudit.updated_by)
    }
  },
  methods: {
    setRawTextAudit (source) {
      const audit = pickRawTextAudit(source)
      if (audit) this.rawTextAudit = audit
      return !!audit
    },
    initRawTextAudit (position) {
      this.setRawTextAudit(position)
      this.raw_text_baseline = position ? (position.company_raw_text || '') : ''
    },
    beginRawTextSave (text) {
      const value = text || ''
      const changed = value !== this.raw_text_baseline || this.raw_text_unsettled
      if (changed) this.raw_text_unsettled = true
      return { seq: ++this.raw_text_seq, text: value, changed }
    },
    async finishRawTextSave (token, saveResponse) {
      if (!token || !token.changed) return
      if (token.seq !== this.raw_text_seq) return
      this.raw_text_baseline = token.text
      this.raw_text_unsettled = false
      if (this.setRawTextAudit(saveResponse)) return
      if (!this.positionData) return
      try {
        // PUT /positions/:id answers 204, so re-read the two fields.
        const position = await this.$network_utils.getPosition({ id: this.positionData.id })
        if (token.seq !== this.raw_text_seq) return
        this.setRawTextAudit(position)
      } catch (e) {
        // keep the label as it was — the save itself succeeded
      }
    }
  }
}
